import {useState, useEffect} from "react";

export function useData<T>(url: string, init?: RequestInit | undefined): DataResult<T> {
    const [data, setData] = useState<T | undefined>(undefined)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<string>()
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(url, init);
                if (!response.ok){
                    // noinspection ExceptionCaughtLocallyJS
                    throw new Error(response.statusText);
                }
                const json = await response.json();
                setIsLoading(false)
                setData(json)
                setError(undefined)
            } catch (error) {
                console.error(error)
                setError(error?.toString())
                setIsLoading(false)
            }
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData()
    }, [url, init]);
    
    return {
        data: data,
        isLoading: isLoading,
        error: error
    }
}

interface DataResult<T>{
    data?: T
    isLoading: boolean
    error?: string
}